<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.0002 16.0549C13.0002 16.6072 12.5525 17.0549 12.0002 17.0549C11.448 17.0549 11.0002 16.6072 11.0002 16.0549C11.0002 15.5026 11.448 15.0549 12.0002 15.0549C12.5525 15.0549 13.0002 15.5026 13.0002 16.0549Z"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5 10.0547H19C20.1046 10.0547 21 10.9501 21 12.0547V20.0547C21 21.1593 20.1046 22.0547 19 22.0547H5C3.89543 22.0547 3 21.1593 3 20.0547V12.0547C3 10.9501 3.89543 10.0547 5 10.0547Z"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M6.99976 10.0552V7.05518C6.99976 5.72909 7.52654 4.45732 8.46422 3.51964C9.4019 2.58196 10.6737 2.05518 11.9998 2.05518C13.3258 2.05518 14.5976 2.58196 15.5353 3.51964C16.473 4.45732 16.9998 5.72909 16.9998 7.05518V10.0552"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconLockKeyhole',
	props: {
		size: {
			type: [Number, String],
			default: 24
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		strokeWidth: {
			type: [Number, String],
			default: 2
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	}
}
</script>
